import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';
import PythonSvgColor from 'devicon/icons/python/python-plain.svg';

export const PythonColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-python" className={cx('sdkIcon', className)} size={size} {...props}>
    <PythonSvgColor />
  </LegacyIcon>
);
